export const SET_RDSTATION = 'RDSTATION/SET_RDSTATION'
